// ==================== src/api/system/binding.ts ====================
// 对应后端：system.binding.controller.SysUserBiliBindingController
// 请求前缀：/api/binding
import { post } from '@/utils/HttpUtils';

export const systemBindingApi = {
  /** 生成绑定验证码（直播间弹幕绑定） */
  getBindingCaptchaCode: () =>
    post<{ code: string }>('/api/binding/captcha/generate'),

  /** 轮询绑定状态 */
  checkBindingCaptchaStatus: (code: string) =>
    post<{ bound: boolean }>('/api/binding/captcha/status', { code }),

  /** 解绑 B站账号 */
  unbindBiliAccount: (biliUid: number) =>
    post('/api/binding/unbind', { biliUid }),
};